import styled, { css } from 'styled-components';
import { getColor, typeScale } from 'core/utils';
import { resetBtn } from 'styled-manila';

export const Wrapper = styled.div`
	position: relative;

	@media(min-width: 768px) {
		margin-right: 8px;
	}
`;

export const ShareBtn = styled.button`
	${resetBtn};
	display: flex;
	justify-content: center;
	align-items: center;
	width: 42px;
	height: 42px;
`;

export const Links = styled.div`
	position: absolute;
	background: ${getColor('white')};
	border: 1px solid #D8D8D8;
	box-shadow: 0 20px 35px 0 rgba(74,74,74,0.20);
	border-radius: 4px;
	width: 230px;
	top: 100%;
	right: 0;
	transition: 0.2s;
	transform: translateY(-40px);
	pointer-events: none;
	opacity: 0;
	z-index: 9;
	min-height: 280px; /* about 4x height of 'Link' */

	${props => props.isOn && css`
		transform: translateY(0);
		opacity: 1;
		pointer-events: all;
	`}
`;

export const Link = styled.a.attrs({
	target: '_blank',
	rel: 'noopener noreferrer'
})`
	${resetBtn};
	width: 100%;
	text-decoration: none;
	color: ${getColor('dustyGray')};
	display: flex;
	align-items: center;
	padding: 16px;
	transition: 0.2s;
	border-bottom: 1px solid ${getColor('porcelain')};

	&:hover, &:focus {
		color: ${getColor("gray")};
	}

	svg {
		fill: currentColor;
	}

	@media (min-width: 768px) {
		padding: 24px 27px;
	}
`;

export const Icon = styled.div`
	flex-basis: ${typeScale(3)};
	max-width: ${typeScale(3)};
	min-width: ${typeScale(3)};
	${({ noMargin } ) => !noMargin && css`
		margin-right: ${typeScale(2)};
	`}

	svg {
		display: block;
		margin: 0 auto;
		width: 100%;
		height: 100%;
	}
`;
